import { render, staticRenderFns } from "./ScoreIndex.vue?vue&type=template&id=085725a9&"
import script from "./ScoreIndex.vue?vue&type=script&lang=js&"
export * from "./ScoreIndex.vue?vue&type=script&lang=js&"
import style0 from "./ScoreIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports